import React from 'react';
import SuperAdminSidebar from '../components/SuperAdminSidebar';
import AdminTopBar from '../components/AdminTopBar';
import CalendarPage from './CalendarPage';

const InstitutionalCalendarPage = () => {
  const breadcrumbItems = [
    { href: '/institutional-admin/dashboard', label: 'Dashboard' },
    { label: 'Calendar' },
  ];

  return (
    <div className="d-flex vh-100 overflow-hidden">
      <SuperAdminSidebar variant="institutional" />
      <div className="d-flex flex-column flex-grow-1 min-w-0 overflow-auto">
        <AdminTopBar variant="institutional" breadcrumbItems={breadcrumbItems} />
        <div className="flex-grow-1 overflow-auto">
          <CalendarPage embedded hidePageChrome />
        </div>
      </div>
    </div>
  );
};

export default InstitutionalCalendarPage;
